import { render, staticRenderFns } from "./chooseApp.vue?vue&type=template&id=752087fb&scoped=true"
import script from "./chooseApp.vue?vue&type=script&lang=js"
export * from "./chooseApp.vue?vue&type=script&lang=js"
import style0 from "./chooseApp.vue?vue&type=style&index=0&id=752087fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752087fb",
  null
  
)

export default component.exports